module.exports = __webpack_public_path__ + "media/images/product/f_d-174c1e9f4bf6212cd182842b2805f16d.png";